export interface IApiAuthTenant {
    id: string;
    externalTenantId: string;
    name: string;
    type: AuthTenantTypeEnum;
}

export enum AuthTenantTypeEnum {
    Unknown = 0,
    AzureAD = 1
}

export class AuthTenant {
    id: string;
    externalTenantId: string;
    name: string;
    type: AuthTenantTypeEnum;

    get typeName(): string {
        return AuthTenantTypeEnum[this.type];
    }

    public static fromApi(model: IApiAuthTenant): AuthTenant {
        const authTenant = new AuthTenant();
        authTenant.id = model.id;
        authTenant.externalTenantId = model.externalTenantId;
        authTenant.name = model.name;
        authTenant.type = model.type;
        return authTenant;
    }
}
